// 这是一个用来配置pageview事件的配置表
// 只能配置router定义过的path，router.tsx
export const Event = {
  Web3PageView: 'Web3PageView',
  Web3UserClick: 'Web3UserClick',
};

export const Page = {
  HomePage: 'AIDOL_Homepage',
  DeailPage: 'AIDOL_DetailPage',
  ProfilePage: 'AIDOL_Profile',
  VotePopup: 'VotePopup',
};
